import axios from 'axios';
import React, { useEffect, useState } from 'react'
import './AllMovies.css'
import {Link, useSearchParams} from 'react-router-dom'
import Navbar from '../Navbar/Navbar';
import Filter from '../Filter/Filter';
import BASE_URL from '../../constant';
import loadgif from '../../Resources/loading2.gif';
import Footer from '../Footer/Footer';

function AllMovies() {

    const [moviedata, setMovieData] = useState([]);
    const [genre, setGenre] = useState("");
    const [language, setLanguage] = useState("");
    const [searchParams] = useSearchParams();
    const searchQuery  = searchParams.get("searchQuery");
    const [loading, setLoading] = useState(true);
   

    useEffect(()=>{

        let url = `${BASE_URL}/bookmyshow/api/v1/movie`;

        const queryParams = [];

        if (genre) {
            setLoading(true);
            queryParams.push(`genre=${genre}`);
        }

        if (language) {
            setLoading(true);
            queryParams.push(`lan=${language}`);
        }

        if (searchQuery) {
            setLoading(true);
            queryParams.push(`searchText=${searchQuery}`);
        }

        if (queryParams.length > 0) {
            url += "?" + queryParams.join("&");
        }
        
        axios.get(url)
        .then(res=>{
            if (Array.isArray(res.data)) {
                console.log("Data from queries : ",res.data)
                setMovieData(res.data);
                setLoading(false);
            } else {
                setLoading(false);
                console.error("Response data is not an array:", res.data);
            }
        })
        .catch(err => {console.log(err.message);
            setMovieData([]);
            setLoading(false);
        });
    
    },[genre, language, searchQuery]);

    

    return (
        <>
        <Navbar />
        <div className="allmovie-outer">
            <Filter genre={genre} setGenre={setGenre} 
            language={language} setLanguage={setLanguage}  />
            {loading ? <div className='gifContainer'>
                <img src={loadgif} alt="Loading..." /><div>Loading Movies...</div>
            </div> : <div className='allMovieContainer'>
            {
                Array.isArray(moviedata) ? (
                    moviedata.map((movie, index) => (
                        <div key={index} className='moviePoster'>
                            <Link to={"/movie-page/" + movie._id}>
                                <img src={movie.posterImage.url} alt="poster1" className='posterimg' />
                            </Link>
                            <div className="ratings"><i className="fa-solid fa-star icon"></i>&nbsp;  {movie.rating}</div>
                            <div className="movie-name">{movie.name}</div>
                            <div className="genre">{movie.genre}</div>
                        </div>
                    ))
                ) : (
                    <p>No movies found.</p>
                )
            }  
            </div>}
        </div>
        <Footer />
        </>
    )
}

export default AllMovies
